import { MEMBER_RESTRICTION_TOOLTIP } from "./constants";

export function getGroupActionTooltipMessage({
    canEditCoA,
}: {
    canEditCoA: boolean;
}): string | undefined {
    if (!canEditCoA) {
        return MEMBER_RESTRICTION_TOOLTIP;
    }
    return undefined;
}
